module.exports = __webpack_public_path__ + "img/objects-align-right.e88c0ab5.svg";